import { apiBaseUrl } from 'app/src/msw/shopping/staticapi/apiBaseUrl'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

/**
 * Delete order mock based on orderId name
 * @returns orderId is NOT_FOUND returns 404, FAILED returns 400, otherwise 200
 */
export const deleteOrder = http.post<{ orderId: string }, DefaultBodyType, undefined>(
  apiBaseUrl + '/orders/:orderId/cancel',
  async ({ params }) => {
    if (params.orderId === 'NOT_FOUND') {
      return HttpResponse.text('Order not found', { status: 404 })
    } else if (params.orderId === 'FAILED') {
      return HttpResponse.text('The order cannot be cancelled', { status: 400 })
    } else {
      return HttpResponse.text('The order has been cancelled', { status: 200 })
    }
  },
)
